import { handleActions } from 'redux-actions';
import { Actions, serviceMessageSetsSuccess, serviceMessageSetsRequest, serviceMessageSetsFailure, serviceMessageSetDelete, serviceMessageSetsReload } from 'actions/serviceMessageSetActions';
import { Actions as SessionActions } from 'actions/sessionActions';
import { ServiceMessageSet, ServiceMessageSetId, UtcTime } from 'shared/models';
import { omit } from 'lodash';

export type State = Readonly<{
    data: Record<ServiceMessageSetId, ServiceMessageSet>;
    loading: boolean;
    errorKey: string | null;
    nextFetch: UtcTime;
}>;

export const initialState = Object.freeze<State>({
    data: {},
    loading: false,
    errorKey: null,
    nextFetch: 0,
});

export const serviceMessageSetsReducer = handleActions({
    [Actions.SVCMSGSETS_REQUEST]: (state: State, action: ReturnType<typeof serviceMessageSetsRequest>) => {
        const { nextFetch } = action.meta;
        return {
            ...state,
            loading: true,
            nextFetch,
        };
    },

    [Actions.SVCMSGSETS_SUCCESS]: (state: State, action: ReturnType<typeof serviceMessageSetsSuccess>) => {
        const data = action.payload.reduce((obj, ss) => {
            if (ss) {
                obj[ss.id] = ss;
            }
            return obj;
        }, { ...state.data });

        return {
            ...state,
            data,
            errorKey: null,
            loading: false,
        };
    },

    [Actions.SVCMSGSETS_FAILURE]: (state: State, action: ReturnType<typeof serviceMessageSetsFailure>) => {
        return {
            ...state,
            errorKey: action.payload,
            loading: false,
        };
    },

    [Actions.SVCMSGSET_DELETE]: (state: State, action: ReturnType<typeof serviceMessageSetDelete>) => {
        const serviceMessagelSetId = action.payload;
        const { data } = state;
        const serviceMessageSet = data[serviceMessagelSetId];
        if (!serviceMessageSet) {
            return state;
        }
        return {
            ...state,
            data: omit(data, serviceMessagelSetId),
        };
    },

    [Actions.SVCMSGSETS_RELOAD]: (state: State, action: ReturnType<typeof serviceMessageSetsReload>) => {
        return {
            ...state,
            nextFetch: 0,
        };
    },


    //
    //  Session Actions
    //
    [SessionActions.LOGOUT_SUCCESS]: () => {
        return initialState;
    },
} as any, initialState);
